import React from "react";
import { createRoot } from "react-dom/client";
import { unregister } from "./registerServiceWorker";
import { IntlProvider } from "react-intl";
import App from "./app";
import localeLanguageSv from "./i18n/sv.json";
import localeLanguageEn from "./i18n/en.json";
import useLanguageStore from "./stores/useLanguageStore";

function LocalizedApp() {
  const language = useLanguageStore((state) => state.language);
  const i18nConfig = language === "en" ? localeLanguageEn : localeLanguageSv;

  return (
    <IntlProvider locale={i18nConfig.locale} messages={i18nConfig.messages}>
      <App />
    </IntlProvider>
  );
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<LocalizedApp />);

unregister();
